import { Typography, Stack, Grid, Tooltip } from '@mui/material';

import { infoIcon } from 'common/assets/images';
import { ReactComponent as FolderIcon } from 'common/assets/images/folderOpen.svg';
import { ReactComponent as RightChevronIcon } from 'common/assets/images/right-chevron.svg';
import InfoTooltip from 'common/components/Tooltip/Tooltip';
import { HIERARCHY_LABEL } from 'common/constants/TaxonomyConstants';
import { TOOLTIP_TEXT } from 'common/constants/Tooltip';
import { scrollProps } from 'common/utils/utilFunctions';

import styles from './HierarchyCard.module.scss';

interface IHierarchyCardProps {
	coveredLists: string[];
	customStyle?: boolean;
}

const HierarchyCard = (props: IHierarchyCardProps) => {
	const { coveredLists, customStyle } = props;
	const { iconWhiteBackground, iconGrayBackground } = styles;
	return (
		<Grid
			className={
				customStyle
					? styles['custom-levels-container']
					: styles['levels-container']
			}
			sx={scrollProps('x-axis')}
		>
			<Stack
				direction="row"
				className={
					customStyle
						? styles['custom-entity-level-stack']
						: styles['entity-level-stack']
				}
			>
				<div className={styles['hierarchy-title']}>
					<Typography
						className={customStyle ? styles['custom-title'] : styles.title}
					>
						{HIERARCHY_LABEL}
					</Typography>
					<InfoTooltip
						className={styles['overview-info-tooltip']}
						title={TOOLTIP_TEXT.RELATIONSHIP_MAPPING}
					>
						<img src={infoIcon} alt="i" />
					</InfoTooltip>
				</div>

				{coveredLists.length > 0 ? (
					<Grid
						xs={12}
						className={
							customStyle
								? styles['custom-level-items-content']
								: styles['level-items-content']
						}
						direction="row"
					>
						{coveredLists.map((item, index) => (
							<Stack
								direction="row"
								key={item}
								className={
									customStyle
										? styles['custom-level-hierarchy']
										: styles['level-hierarchy']
								}
							>
								<Stack
									key={item}
									direction="row"
									alignItems="center"
									className={`${
										customStyle
											? styles['custom-level-item-container']
											: styles['level-item-container']
									} ${
										index + 1 === coveredLists.length
											? styles['highlight-item']
											: ''
									}`}
								>
									<FolderIcon
										fill={
											index + 1 === coveredLists.length
												? iconWhiteBackground
												: iconGrayBackground
										}
										className={
											index + 1 === coveredLists.length
												? styles['selected-folder-icon']
												: styles['folder-icon']
										}
									/>

									<Tooltip title={item} data-test-id="tool-tip">
										<Typography
											className={styles['level-item-text']}
											data-testId="level-item"
										>
											{`${item?.slice(0, 30)}${
												item?.length > 30 ? '...' : '    '
											}`}
										</Typography>
									</Tooltip>
								</Stack>
								<Stack justifyContent="center">
									{index + 1 !== coveredLists.length &&
										customStyle === false && (
											<RightChevronIcon
												fill={iconGrayBackground}
												className={styles['hierarchy-right-icon']}
											/>
										)}
								</Stack>
							</Stack>
						))}
					</Grid>
				) : (
					<Stack className={styles['no-data-content']}>
						<h3>
							<i>No items to display</i>
						</h3>
					</Stack>
				)}
			</Stack>
		</Grid>
	);
};

export default HierarchyCard;
